"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tooltip = void 0;

var _swatches = require("../swatches");

var tooltip = {
  text: _swatches.monochrome.white,
  bg: _swatches.monochrome.black
};
exports.tooltip = tooltip;
//# sourceMappingURL=tooltip.js.map